module.exports = __webpack_public_path__ + "static/media/xp-banner5.f80f7d3e.jpg";